import React, { Suspense } from 'react';
import UILoader from 'components/UI/Loader/Loader';
import BaseLayout from 'components/BaseLayout/BaseLayout';
import UIPageTitle from 'components/UI/PageTitle/PageTitle';
import DocumentTitle from 'components/DocumentTitle/DocumentTitle';

const ToolsConnector = React.lazy(() => import('components/Tools/Tools'));

function ScreensTools() {
  return (
    <BaseLayout>
      <DocumentTitle>Tools</DocumentTitle>
      <UIPageTitle description="List of utilities and system tools">
        Tools
      </UIPageTitle>
      <Suspense fallback={<UILoader />}>
        <ToolsConnector />
      </Suspense>
    </BaseLayout>
  );
}

export default ScreensTools;
